export default {
  __default: {
    display: 'flex',
    flexDirection: 'column',

    fontSize: 2,

    '--gap-rte': 'var(--rte)',
    '--gap-li': ['1.2em', null, '0.85em'],

    '&>': { '* + *': { mt: 'var(--gap-rte)' } },

    'b, strong': {
      fontWeight: 600,
    },

    'ul, ol': {
      display: 'grid',
      fontSize: 'inherit',
      listStyle: 'revert',

      pl: 'var(--gap-li)',
      gridGap: 'var(--gap-li)',

      li: {
        pl: '0.5em',

        '> ul, > ol': { mt: 'var(--gap-li)' },
        '> p': {
          my: 'unset',
          fontSize: 'inherit',
          // lineHeight: 1,
          display: 'inline-table',
        },
      },
    },
    'ol > li::marker': { fontSize: '0.7em' },
  },
}
